import { Button, Text, Flex } from '@chakra-ui/react';
import ConfirmModal from '../../../common/ConfirmModal';
import { formatCustomPlanName } from '../../../utils/subscriptionUtils';

const contractSuffix = (contractLength) =>
  contractLength ? `, ${contractLength} months contract` : '';

const AcceptCustomPlanModal = ({
  isOpen,
  onClose,
  loading,
  onSuccess,
  newPlan,
  formatPrice,
  billingIntervalOverride,
  amountOverride,
}) => {
  const billingInterval =
    billingIntervalOverride ?? newPlan?.billingInterval ?? 'monthly';
  const contract = contractSuffix(newPlan?.contractLength);

  const priceAndBillingCopy = () => {
    const amt = formatPrice(amountOverride ?? newPlan.offeredPlan.amount);
    switch (billingInterval) {
      case 'annually':
        return (
          <>
            {amt} per year (billed annually{contract}).
          </>
        );
      case 'quarterly':
        return (
          <>
            {amt} per quarter (billed every 3 months{contract}).
          </>
        );
      case 'semiannually':
        return (
          <>
            {amt} per 6 months (billed semi-annually{contract}).
          </>
        );
      case 'monthly':
      default:
        return (
          <>
            {amt} per month (billed monthly{contract}).
          </>
        );
    }
  };

  if (newPlan?.contractRequired && newPlan?.status === 'offer_sent') {
    return (
      <ConfirmModal
        isOpen={isOpen}
        onClose={onClose}
        title="Review & confirm"
        primaryButton={{
          label: 'Accept Offer',
          onClick: onSuccess,
          loadingText: 'Processing',
          isLoading: loading,
        }}
        secondaryButton={{
          label: 'Cancel',
          onClick: onClose,
        }}
      >
        <Flex direction="column" w="100%">
          <Text mb={4}>
            By clicking 'Accept offer' you are accepting the terms of{' '}
            <b>{formatCustomPlanName(newPlan.offeredPlan.name)}</b>.
          </Text>
          <Text>
            Once accepted you will receive a contract for your signature to
            proceed.
          </Text>
        </Flex>
      </ConfirmModal>
    );
  }

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      title="Review & Confirm"
      primaryButton={{
        label: 'Confirm & Pay',
        onClick: onSuccess,
        loadingText: 'Processing',
        isLoading: loading,
      }}
      secondaryButton={{
        label: 'Cancel',
        onClick: onClose,
      }}
    >
      <Flex direction="column" w="100%">
        <Text mb={4}>
          You're about to switch to a{' '}
          <b>{formatCustomPlanName(newPlan.offeredPlan.name)}</b> plan. Your new
          limits will apply immediately and you won't lose any existing
          templates or passes.
        </Text>
        <Text mb={4} fontWeight="bold">
          New price: {priceAndBillingCopy()}
        </Text>
        <Text>
          You'll only pay the difference today – any unused time from your
          current plan will be credited.
        </Text>
      </Flex>
    </ConfirmModal>
  );
};

export default AcceptCustomPlanModal;
